import React from "react";
import { Row, Col, NavLink } from "react-bootstrap";
import DefaultPhoto from "../../assets/images/contactus/defaultavatar.png";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

export default function Team({ committeeList }) {
  return (
    <section className="team-section my-5">
      <div className="d-flex justify-content-center text-center team-header mb-4">
        {/* <div className="d-flex justify-content-center align-items-center flex-column ms-auto"> */}
        <div className="d-flex justify-content-center align-items-center flex-column ms-auto">
          <h2 className="team-title mb-2 h1">Meet Our Teams</h2>
          <p className="team-subtitle">
            Our dedicated committee members work tirelessly to bring our
            community together through cultural events and programs
          </p>
        </div>
        {committeeList && committeeList.length > 4 && (
          <NavLink href="/committee" className="view-all-link ms-auto">
            View All
          </NavLink>
        )}
      </div>

      <Row className="align-items-center justify-content-center gx-3">
        {committeeList &&
          committeeList.length > 0 &&
          committeeList.map((m) => (
            <Col
              key={m._id}
              xs={6}
              sm={4}
              md={4}
              lg={2}
              className="text-center mb-4 team-member-col"
            >
              <div className="team-member-card">
                <div
                  className="team-avatar mb-3 position-relative"
                  style={{ border: "2px solid #EDA92B" }}
                >
                  <img
                    src={
                      m?.picture_path
                        ? `${IMAGE_BASEURL}${m?.picture_path}`
                        : DefaultPhoto
                    }
                    alt={m?.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                      padding: "10px",
                    }}
                  />
                </div>

                <div className="team-name fw-600">{m?.name}</div>
                <div className="team-role text-muted small">{m?.position}</div>
              </div>
            </Col>
          ))}
      </Row>
    </section>
  );
}
